module.exports = __webpack_public_path__ + "img/tc1.6467918c.jpg";